/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure the export format, filters, and fields before downloading." |
*
* @param {Audit_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_description = /** @type {((inputs?: Audit_Export_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Format, Filter und Felder vor dem Download.")
	return /** @type {LocalizedString} */ ("Configure the export format, filters, and fields before downloading.")
});